import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import dateFormat from 'dateformat';

import Api from '../../../../services/Api';

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      grid: {
        color: 'rgba(200, 200, 200, 0.1)',
      },
      ticks: {
        padding: 8,
        font: {
          size: 11,
          family: "'Poppins', sans-serif",
        }
      }
    },
    x: {
      grid: {
        color: 'rgba(200, 200, 200, 0.1)',
      },
      ticks: {
        maxRotation: 0,
        autoSkip: true,
        maxTicksLimit: 12,
        padding: 5,
        font: {
          size: 10,
          family: "'Poppins', sans-serif",
        }
      }
    },
  },
  plugins: {
    tooltip: {
      backgroundColor: 'rgba(28, 66, 32, 0.8)',
      titleFont: {
        family: "'Poppins', sans-serif",
        size: 12
      },
      bodyFont: {
        family: "'Poppins', sans-serif",
        size: 12
      },
      padding: 10,
      cornerRadius: 6
    },
    legend: {
      position: 'top',
      align: 'end',
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        padding: 15,
        usePointStyle: true,
        pointStyle: 'rectRounded',
        font: {
          family: "'Poppins', sans-serif",
          weight: '500',
          size: 11
        }
      }
    },
    datalabels: {
      color: '#fff',
      font: {
        weight: 'bold',
        size: 11,
      },
      formatter: function(value) {
        if (value > 0) return value;
        return '';
      },
      anchor: 'end',
      align: 'start',
      offset: 0,
      display: function(context) {
        return context.dataset.data[context.dataIndex] > 0;
      }
    }
  }
}

const plugins = [{
  afterDraw: function (chart) {
    if (chart.data.datasets.length > 0) {
      if (chart.data.datasets[0].data.every(item => item === 0)) {
        var width = chart.width,
          height = chart.height,
          ctx = chart.ctx;
        ctx.restore();
        var fontSize = (height / 160).toFixed(2);
        ctx.font = fontSize + "em 'Poppins', sans-serif";
        ctx.textBaseline = "top";
        ctx.fillStyle = '#1c4220';
        var text = "Nenhuma Informação Disponível",
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    }
  }
}]

const Graphics = (props) => {
  const { equipaments } = props;

  // Cor da marca
  const colorPrimary = '#1c4220';
  const colorSecondary = '#8fad15';

  const [sumDia, setSumDia] = useState('');
  const [sumMes, setSumMes] = useState('');

  const [volumeDias, setVolumeDias] = useState({
    labels: [],
    datasets: []
  });

  const [volumeMes, setVolumeMes] = useState({
    labels: [],
    datasets: []
  });

  useEffect(() => {
    const getData = async () => {
      try {
        var { data } = await Api.post('/measurements/volume', { filter: equipaments });
      } catch (err) {
        setVolumeDias([])
        return
      }
      var labels = data.day.map(i => {
        var date = new Date(0);
        date.setHours(i.hour - 3);
        var timeString = date.toISOString().substring(11, 16);
        return timeString;
      });

      var quantity = data.day.map(i => i.count)
      setSumDia(quantity.reduce((a, b) => a + b, 0))

      setVolumeDias({
        labels,
        datasets: [
          {
            labels,
            label: `Medidas dia`.toUpperCase(),
            data: data.day.map(i => i.count),
            backgroundColor: function(context) {
              const chart = context.chart;
              const { ctx, chartArea } = chart;
              if (!chartArea) return;
              
              const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
              gradient.addColorStop(0, 'rgba(143, 173, 21, 0.7)');
              gradient.addColorStop(1, 'rgba(28, 66, 32, 0.9)');
              return gradient;
            },
            borderColor: colorPrimary,
            borderWidth: 1,
            borderRadius: 4,
            borderSkipped: false,
            hoverBackgroundColor: colorSecondary,
            maxBarThickness: 35,
            barPercentage: 0.8,
            categoryPercentage: 0.8,
            datalabels: {
              display: function(context) {
                // Mostrar apenas valores maiores para evitar sobreposição
                return context.dataset.data[context.dataIndex] > 0;
              }
            },
          }
        ],
      });

      labels = data.month.map(i => dateFormat(i.day, "UTC:dd"));
      quantity = data.month.map(i => i.count)
      setSumMes(quantity.reduce((a, b) => a + b, 0))

      setVolumeMes({
        labels,
        datasets: [
          {
            labels,
            label: `Medidas mês`.toUpperCase(),
            data: data.month.map(i => i.count),
            backgroundColor: function(context) {
              const chart = context.chart;
              const { ctx, chartArea } = chart;
              if (!chartArea) return;
              
              const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
              gradient.addColorStop(0, 'rgba(143, 173, 21, 0.7)');
              gradient.addColorStop(1, 'rgba(28, 66, 32, 0.9)');
              return gradient;
            },
            borderColor: colorPrimary,
            borderWidth: 1,
            borderRadius: 4,
            borderSkipped: false,
            hoverBackgroundColor: colorSecondary,
            maxBarThickness: 35,
            barPercentage: 0.8,
            categoryPercentage: 0.8,
            datalabels: {
              display: function(context) {
                // Mostrar apenas valores maiores para evitar sobreposição
                return context.dataset.data[context.dataIndex] > 0;
              }
            },
          }
        ],
      })

    }
    getData();
  }, [equipaments]);

  return (
    <Card className="border-0 shadow-sm mb-2" style={{ borderRadius: '12px', overflow: 'hidden' }}>
      <Card.Header 
        style={{
          background: 'linear-gradient(to right, rgba(28, 66, 32, 0.9), rgba(143, 173, 21, 0.8))',
          borderBottom: 'none',
          padding: '15px 20px'
        }}
      >
        <h5 className='text-white mb-0 fw-bold' style={{ letterSpacing: '0.5px' }}>Volume de medidas</h5>
      </Card.Header>
      <Card.Body className="p-4">
        <Row className='g-4'>
          <Col xs={12} md={6}>
            <div style={{ textAlign: 'center' }}>
              <p className="fw-medium mb-3" style={{ color: '#1c4220' }}>
                Medidas dia: <span className="fw-bold">{sumDia}</span>
              </p>
              <div className="chart-container" style={{ position: 'relative', height: '250px' }}>
                <Bar
                  options={options}
                  data={volumeDias}
                  plugins={plugins}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div style={{ textAlign: 'center' }}>
              <p className="fw-medium mb-3" style={{ color: '#1c4220' }}>
                Medidas mês: <span className="fw-bold">{sumMes}</span>
              </p>
              <div className="chart-container" style={{ position: 'relative', height: '250px' }}>
                <Bar
                  options={options}
                  data={volumeMes}
                  plugins={plugins}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}
export default Graphics;
